"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gallery = void 0;

var photoswipe_ui_default_1 = __importDefault(require("photoswipe/dist/photoswipe-ui-default"));

var react_1 = __importStar(require("react"));

var _1 = require(".");

var gallery_base_1 = require("./gallery-base");
/**
 * Gallery component with default Layout and UI
 */


var Gallery = function (_a) {
  var children = _a.children,
      options = _a.options,
      id = _a.id,
      onOpen = _a.onOpen,
      restProps = __rest(_a, ["children", "options", "id", "onOpen"]);

  var defaultLayoutRef = react_1.useRef();
  return react_1.default.createElement(_1.CustomGallery, {
    layoutRef: defaultLayoutRef,
    ui: photoswipe_ui_default_1.default,
    options: options,
    id: id,
    onOpen: onOpen
  }, children, react_1.default.createElement(_1.DefaultLayout, __assign({}, restProps, {
    ref: defaultLayoutRef
  })));
};

exports.Gallery = Gallery;
exports.Gallery.propTypes = __assign(__assign({}, gallery_base_1.baseGalleryPropTypes), _1.layoutPropTypes);